import { ref, computed } from 'vue'
import AuthService from '../services/AuthService'
import { usePermissionStore } from './permissionStore'

function syncPermissions() {
  try {
    usePermissionStore().hydrateFromStorage()
  } catch {
    // Pinia is not active during early module setup.
  }
}

function clearPermissions() {
  try {
    usePermissionStore().clear()
  } catch {
    // Pinia is not active during early module setup.
  }
}

const isAuthenticated = ref(false)
const user = ref(null)

// Initialize from localStorage on module load
const initializeAuth = () => {
  isAuthenticated.value = AuthService.isAuthenticated()
  if (isAuthenticated.value) {
    user.value = AuthService.getCurrentUser()
  }
}

// Initialize on module load
initializeAuth()

export function useAuthStore() {
  const login = async (credentials) => {
    try {
      const response = await AuthService.login(credentials)
      
      // Update state after successful login
      isAuthenticated.value = true
      user.value = AuthService.getCurrentUser()
      syncPermissions()
      
      return { success: true, data: response }
    } catch (error) {
      isAuthenticated.value = false
      user.value = null
      throw error
    }
  }

  const logout = () => {
    AuthService.logout()
    localStorage.clear()
    sessionStorage.clear()
    isAuthenticated.value = false
    user.value = null
    clearPermissions()
  }

  // Check authentication status (useful for reactive updates)
  const checkAuth = () => {
    isAuthenticated.value = AuthService.isAuthenticated()
    if (isAuthenticated.value) {
      user.value = AuthService.getCurrentUser()
      syncPermissions()
    } else {
      user.value = null
      clearPermissions()
    }
  }

  return {
    isAuthenticated: computed(() => isAuthenticated.value),
    user: computed(() => user.value),
    login,
    logout,
    checkAuth
  }
}

